const Modal = {
  state: {
    modalActive: false,
    modal: {
      exitGame: false,
      cropImageProfile: false,
      finishGame: false,
      noAccessGame: false,
      updateVersionApp: false
    }
  },
  actions: {
    openModalExitGame: ({commit}) => {
      commit('SET_modalActive', true)
      commit('SET_modalExitGame', true)
    },
    openModalCropImageProfile: ({commit}) => {
      commit('SET_modalActive', true)
      commit('SET_modalCropImageProfile', true)
    },
    openModalFinishGame: ({commit}) => {
      commit('SET_modalActive', true)
      commit('SET_modalFinishGame', true)
    },
    openModalNoAccessGame: ({commit}) => {
      commit('SET_modalActive', true)
      commit('SET_modalNoAccessGame', true)
    },
    openModalUpdateVersionApp: ({commit}) => {
      commit('SET_modalActive', true)
      commit('SET_modalUpdateVersionApp', true)
    },
    closeModal: ({commit}) => {
      commit('SET_modalActive', false)
      commit('SET_modalExitGame', false)
      commit('SET_modalCropImageProfile', false)
      commit('SET_modalFinishGame', false)
      commit('SET_modalNoAccessGame', false)
      commit('SET_modalUpdateVersionApp', false)
    }
  },
  mutations: {
    SET_modalActive(state, data) {
      state.modalActive = data
    },
    SET_modalExitGame(state, data) {
      state.modal.exitGame = data
    },
    SET_modalCropImageProfile(state, data) {
      state.modal.cropImageProfile = data
    },
    SET_modalFinishGame(state, data) { 
      state.modal.finishGame = data
    },
    SET_modalNoAccessGame(state, data) {
      state.modal.noAccessGame = data
    },
    SET_modalUpdateVersionApp(state, data) {
      state.modal.updateVersionApp = data
    }
  }
}

export default Modal